

















import Vue from "vue";
import Component from "vue-class-component";
import { MedicalInvoice } from "@/components/medicalEdit/types";
import { Prop } from "vue-property-decorator";

@Component({})
export default class Money extends Vue {
  @Prop() tab!: MedicalInvoice;
}
